// These come right from header contract - currently https://github.com/dsg-tech/search-calia-navigation/blob/develop/src/types/index.ts

export type LoyaltySuggestedMessaging =
  | 'REWARDS_AVAILABLE'
  | 'POINTS_TO_REWARD'
  | 'CLAIM_5_DOLLAR'
  | 'SHOP_TO_EARN'
  | 'PENDING_REWARDS';

export type LoyaltyDisplayTier = 'ScoreCard' | 'ScoreCardPlus' | 'ScoreCardGold';

export type RewardDisplayTier = LoyaltyDisplayTier | 'Gold';

export type LoyaltyRewardStatus = 'Available' | 'Redeemed' | 'Pending' | 'Expired';

export interface LoyaltyAddress {
  addressId: string;
  identityId: string;
  firstName: string;
  lastName: string;
  addressLine1: string;
  addressLine2: string | null;
  city: string;
  state: string;
  zip: string;
  country: string;
  phone: string | null;
}

export interface LoyaltyTierWindow {
  tierStartDate: string;
  tierExpiration: string;
}

export interface LoyaltyIdentity {
  identityId: string;
  scorecard: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  createdStore: number | null;
  createdSource: string;
  primaryAddress: string | null;
  addresses: LoyaltyAddress[];
}

export interface LoyaltyTiers {
  displayTier: LoyaltyDisplayTier;
  memberSince: string;
  currentYearSales: number;
  spendNeededForGold: number;
  isGold: boolean;
  isCreditGold: boolean;
  ScorecardPlus?: LoyaltyTierWindow;
  ScoreCardPlus?: LoyaltyTierWindow;
  Gold?: LoyaltyTierWindow;
  CreditGold?: LoyaltyTierWindow;
  ScoreCardGold?: LoyaltyTierWindow;
}

export interface LoyaltyPointsProgress {
  subAccount: string;
  currentPointBalance: number;
  rewardAmount: number;
  pointsToNextReward: number;
  currentRewardTier: number;
  nextRewardTier: number;
  currentInstantRewardTier: number;
}

export interface LoyaltyReward {
  rewardId: string;
  description: string;
  message: string;
  iconText: string;
  badgeText?: string;
  offerCode: string;
  displayTier: RewardDisplayTier;
  status: LoyaltyRewardStatus;
  displayToAthlete: boolean;
  expirationDateTime: string;
  redeemedDate: string | null;
  pCode: string | null;
  pricingDiscountId: string | null;
  sendOfferCodeToPricing?: boolean;
  sendToPricing?: boolean;
  availableUses: number;
}

export interface LoyaltyData {
  identity: Partial<LoyaltyIdentity>;
  tier: Partial<LoyaltyTiers>;
  points: Partial<LoyaltyPointsProgress>;
  suggestedMessaging: Partial<LoyaltySuggestedMessaging>;
  promosAvailable: 0 | 1;
  rewards: LoyaltyReward[];
}
